import { SnackbarDescriptionVariants } from './snackbar-description.styles'

type SnackbarDescriptionProps = {
  children?: React.ReactNode
}

export const SnackbarDescription = (props: SnackbarDescriptionProps) => {
  const { children } = props
  return (
    <p
      className={SnackbarDescriptionVariants({})}
      data-testid="snackbar-description"
      aria-label={children?.toString()}
    >
      {children}
    </p>
  )
}
